export default [
  {
    path: '/admin/apply/app/version',
    name: 'plugin36AppVersion',
    component: () => import('@/views/apply/app/version.vue'),
    meta: {
      title: '版本管理',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/app/settings',
    name: 'plugin36AppSettings',
    component: () => import('@/views/apply/app/settings.vue'),
    meta: {
      title: '原生App配置',
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/app.js